var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "intercom"
  }, [_c('div', {
    ref: "interviewBox",
    staticClass: "intercomContent"
  }, [_c('div', {
    ref: "videoCanvas",
    staticClass: "communication-units"
  }, [_c('Source', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: false,
      expression: "false"
    }],
    staticClass: "is-local",
    attrs: {
      "title": "Me",
      "singChannel": _vm.channels[_vm.rtilCode],
      "userInfo": _vm.userInfo,
      "rtc": _vm.rtc
    }
  }, [_c('div', {
    attrs: {
      "id": "local_stream"
    }
  })]), _vm._l(_vm.communicationUnits, function (item, index) {
    return _c('div', {
      key: index,
      staticClass: "communication-unit",
      style: {
        width: _vm.unitWidth
      }
    }, [_c('div', {
      staticClass: "communication-body",
      style: {
        height: _vm.communicateBodyHeight
      }
    }, [_c('div', {
      ref: "unit",
      refInFor: true,
      staticClass: "communication-header"
    }, [_c('div', {
      staticClass: "current-unit"
    }, [_vm._v(_vm._s(item.slotNum))]), _c('div', {
      staticClass: "communication-title"
    }, [_vm._v("Talk with:")]), _c('div', {
      staticClass: "connected-units"
    }, _vm._l(item.connectedTo, function (slot) {
      return _c('div', {
        key: slot,
        staticClass: "connected-unit",
        class: {
          active: _vm.isSlotActive(item.slotNum, slot),
          disabled: !_vm.hasParticipantRtilCode(slot, item.slotNum)
        },
        on: {
          "click": function ($event) {
            _vm.hasParticipantRtilCode(slot, item.slotNum) && _vm.toggleConnection(item.slotNum, slot);
          }
        }
      }, [_vm._v(" " + _vm._s(slot) + " ")]);
    }), 0)]), _c('div', {
      staticClass: "shareLink"
    }, [_c('div', {
      staticClass: "participant-name"
    }, [_vm._v(_vm._s(item.participantRtilCode ? _vm.behaviorInfo[item.participantRtilCode] : 'Share the link to invite'))]), _c('div', {
      staticClass: "participant-link"
    }, [_c('i', {
      directives: [{
        name: "clipboard",
        rawName: "v-clipboard:copy",
        value: _vm.urlAddress(item.slotNum),
        expression: "urlAddress(item.slotNum)",
        arg: "copy"
      }, {
        name: "clipboard",
        rawName: "v-clipboard:success",
        value: _vm.onCopy,
        expression: "onCopy",
        arg: "success"
      }, {
        name: "clipboard",
        rawName: "v-clipboard:error",
        value: _vm.onError,
        expression: "onError",
        arg: "error"
      }],
      staticClass: "icon-link iconfont copy"
    })])]), _c('Source', {
      key: item.participantRtilCode,
      ref: `remoteSingleSource${item.participantRtilCode}`,
      refInFor: true,
      attrs: {
        "output": false,
        "slotNum": item.slotNum,
        "bookLiveInfos": _vm.bookLiveInfos[item.slotNum],
        "isAudioLevel": _vm.audioLevel,
        "devicePlatform": _vm.devicePlatform[item.participantRtilCode],
        "title": item.participantRtilCode + '',
        "nickName": _vm.behaviorInfo[item.participantRtilCode],
        "avatar": _vm.avatarInfo[item.participantRtilCode] || '',
        "tagName": _vm.tagNameInfo[item.participantRtilCode],
        "singChannel": _vm.channels[item.participantRtilCode],
        "volume": _vm.voiceList[item.participantRtilCode] || {},
        "fullScreenInfo": _vm.fullScreenInfo[item.participantRtilCode],
        "selectRids": _vm.voipInfo[item.participantRtilCode] ? _vm.voipInfo[item.participantRtilCode] : '',
        "muteVideo": !_vm.State.cameraStatus[item.participantRtilCode],
        "muteAudio": !_vm.State.micStatus[item.participantRtilCode],
        "userInfo": _vm.userInfo,
        "remoteNetWorks": _vm.remoteNetWorks[item.participantRtilCode],
        "liveInfo": _vm.deviceStatusObj[item.participantRtilCode] && _vm.deviceStatusObj[item.participantRtilCode].type == 'T' ? _vm.deviceStatusObj[item.participantRtilCode] || {} : _vm.rtilStatusObj[item.participantRtilCode] || {},
        "allRList": _vm.allRList,
        "rtcLoaded": _vm.rtcLoaded,
        "devicesInfo": _vm.otherMediaInfo[item.participantRtilCode],
        "degreeHost": _vm.degreeHost[item.participantRtilCode],
        "sourceType": _vm.rtilCodeKeyTypeVal[item.participantRtilCode],
        "rtc": _vm.rtc
      },
      on: {
        "changeSourceList": _vm.changeSourceList,
        "changeR": _vm.changeR,
        "operatCallback": _vm.operateCallback,
        "changeRList": _vm.changeAllRList,
        "callBack": _vm.openliveAndLazyAudio,
        "setBookLive": _vm.setBookLive
      }
    }), _c('div', {
      staticClass: "video-return"
    }, [_vm._v(" Send a Video Return to the participant: ")]), _c('Source', {
      key: `mainWindow${item.slotNum}`,
      ref: `mainWindow${item.slotNum}`,
      refInFor: true,
      staticClass: "outPut",
      attrs: {
        "output": true,
        "slotNum": item.slotNum,
        "devicePeerId": _vm.devicePeerId[item.mainWindowRtilCode] || '',
        "singChannel": _vm.channels[item.mainWindowRtilCode],
        "userInfo": _vm.userInfo,
        "title": item.mainWindowRtilCode,
        "nickName": _vm.behaviorInfo[item.mainWindowRtilCode],
        "avatar": _vm.avatarInfo[item.mainWindowRtilCode] || '',
        "tagName": _vm.tagNameInfo[item.mainWindowRtilCode],
        "volume": _vm.voiceList[item.mainWindowRtilCode] || {},
        "muteVideo": !_vm.State.cameraStatus[item.mainWindowRtilCode],
        "muteAudio": !_vm.State.micStatus[item.mainWindowRtilCode],
        "remoteNetWorks": _vm.remoteNetWorks[item.mainWindowRtilCode],
        "degreeHost": _vm.degreeHost[item.mainWindowRtilCode],
        "outputRtilCode": item.mainWindowRtilCode,
        "rtc": _vm.rtc,
        "isAudioLevel": _vm.audioLevel
      },
      on: {
        "operatCallback": _vm.operateCallback
      }
    })], 1), _c('div', {
      staticClass: "communicateControl"
    }, [_c('div', {
      staticClass: "control"
    }, [_c('el-tooltip', {
      staticClass: "item",
      attrs: {
        "effect": "dark",
        "content": _vm.hostConnections[item.slotNum] ? _vm.$t('commonPartyHost.turnOffInterview') : _vm.$t('commonPartyHost.turnOnInterview'),
        "placement": "top"
      }
    }, [_c('div', {
      staticClass: "icon-container",
      class: {
        active: _vm.communicate
      }
    }, [!_vm.hostConnections[item.slotNum] ? _c('i', {
      staticClass: "iconfont icon-a-intercomoff2",
      class: {
        disabled: !item.participantRtilCode && !_vm.hostConnections[item.slotNum]
      },
      on: {
        "click": function ($event) {
          return _vm.hostCommunicate(item);
        }
      }
    }) : _c('i', {
      staticClass: "iconfont icon-a-intercomon",
      on: {
        "click": function ($event) {
          return _vm.hostCommunicate(item);
        }
      }
    })])])], 1)])]);
  })], 2)]), _c('Foot', {
    ref: "footDiv",
    attrs: {
      "rtc": _vm.rtc,
      "userInfo": _vm.userInfo,
      "rtilCode": _vm.rtilCode,
      "rtcLoaded": _vm.rtcLoaded,
      "showIconArray": _vm.iconList,
      "devicesInfo": _vm.devicesInfo,
      "mic": _vm.State.micStatus[_vm.rtilCode],
      "speakerDevice": _vm.devicesInfo.speakerList,
      "microphoneDevice": _vm.devicesInfo.microphoneList
    },
    on: {
      "eventCallback": _vm.dealFootEvent
    }
  }), _c('tipsDailog', {
    staticClass: "repeatJoin",
    attrs: {
      "width": "550px",
      "info": _vm.repeatInfo
    },
    on: {
      "save": function ($event) {
        _vm.repeatInfo.show = false;
      }
    }
  }, [_c('div', {
    staticClass: "email"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('common.repeatContent')))])])])], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };